<template>
    <div class="usero_info_00">
        <div v-for="(el,index) in list" class="usero_info_01" :key="index">
            <div class="usero_info_02">{{el.label}}</div>
            <div class="usero_info_03">
                <img v-if="el.type=='img'" :class="['imgd',el.cls]" :src="datad[el.prop]"/>
                <span v-else>
                    {{el.clfn?el.clfn(datad):datad[el.prop]}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        props:{
            datas:Object
        },
        computed:{
            datad(){
                return this.datas.works_info || {}
            }
        },
		data() {
			return {
                list:[
                    {label:'用户ID',prop:'open_id'},
                    {label:'头像',prop:'avatar',type:'img',cls:'avatar'},
                    {label:'用户昵称',prop:'username'},
                    {label:'作品id',prop:'work_id'},
                    {label:'作品名称',prop:'work_name'},
                    {label:'封面图',prop:'face_pic',type:'img'},
                    {label:'邀请j记录id',prop:'invitees_id'},
                    {label:'邀稿状态',clfn:da=>{
                        const md = {
                            '1':'邀稿中',
                            '2':'已交稿'
                        };
                        return md[da.invitees_status] || ''
                           
                    }},
                    {label:'邀稿人昵称',prop:'invitees'},
                    {label:'邀稿时间',prop:'invitees_time'},


                ],
			}	
				
		},
		watch:{

		},

		methods: {
			
			
		},
	}
</script>

<style lang="scss" scoped>

.usero_info_00{
    padding:60px 0 60px 196px;
}
.usero_info_01{
    display: flex;
   
    margin-bottom: 20px;
}
.usero_info_02{
    width: 100px;
    margin-right: 30px;
}
.usero_info_03{
    flex: 1;
}
.avatar{
    width: 120px;
}
</style>

